import OregonCityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { klamathFallsConfig } from "./data";

export default function KlamathFallsPage() {
  return <OregonCityPageTemplate config={klamathFallsConfig} />;
}